import { CookieConsent } from "@jmc/solid-design-system/src/utils/cookieConsent";
import { useEffect, useState } from "react";
import yn from "yn";

export const useCookieInteraction = (): { interacted: boolean; accepted: string } => {
    const [interacted, setInteracted] = useState(false);
    const [accepted, setAccepted] = useState("");

    useEffect(() => {
        const isAlertBoxClosed = (): void => {
            try {
                // A few sites grant by default the performance cookie (opt-out mode)
                // https://confluence.jnj.com/pages/viewpage.action?pageId=546733891#PrivacyControls[JJMC]-Tagsaresentonlywhenappropriateuserconsentisgiven
                const optanonActiveGroups = (window as Window)?.OptanonActiveGroups?.split(",") || [];
                const isPerformanceCookieGranted = optanonActiveGroups.includes(`${CookieConsent.PERFORMANCE_COOKIES}`);
                process.env.GATSBY_DISABLE_COOKIEBANNER === "false" && process.env.GATSBY_ONETRUST_DATA_DOMAIN
                    ? setInteracted((window as Window)?.OneTrust?.IsAlertBoxClosed() || isPerformanceCookieGranted)
                    : setInteracted(true);

                setAccepted((window as Window)?.OptanonActiveGroups);
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
            } catch (error) {
                //will end up here if is alert box closed in onetrust is missing
                process.env.GATSBY_DISABLE_COOKIEBANNER === "false" && process.env.GATSBY_ONETRUST_DATA_DOMAIN
                    ? setInteracted(yn(process.env.GATSBY_DEFAULT_ACCEPT_COOKIES))
                    : setInteracted(true);

                setAccepted((window as Window)?.OptanonActiveGroups);
            }
        };
        isAlertBoxClosed();
        window.addEventListener("OptanonActiveGroupsChanged", isAlertBoxClosed);
        return (): void => {
            window.removeEventListener("OptanonActiveGroupsChanged", isAlertBoxClosed);
        };
    });

    return { interacted, accepted };
};
